export const loadKlaviyo = () => {
  const klaviyoKey = process.env.REACT_APP_KLAVIYO_PUBLIC_KEY

  if (!klaviyoKey) {
    console.error("Klaviyo public key is missing.")
    return
  }

  const script = document.createElement("script")
  script.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${klaviyoKey}`
  script.async = true
  script.onload = () => {
    console.log("Klaviyo script loaded successfully.")
  }

  document.body.appendChild(script)
}
export const logOutKlaviyo = () => {
  document.cookie = `_kuid_=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`
}
